// src/Login.tsx
import React, { useState, useContext, useEffect } from 'react';
import { MyContext } from '../context/my_context';
import '../assets/styles/login.css';
import logoAlcaldia from '../assets/images/logos/logo-alcaldia-color-letra-negra.png';
import logoSivep from '../assets/images/logos/Logo-sivep-final.png';
import userIcon from '../assets/images/icons/user-icon.jpeg';
import padlockIcon from '../assets/images/icons/padlock-icon.jpeg';
import Ventero1B from '../assets/images/sellers/Ventero-1B.jpg';
import Ventero2B from '../assets/images/sellers/Ventero-2B2.jpg';
import Ventero3B from '../assets/images/sellers/Ventero-3B2.jpg';
import Ventero4B from '../assets/images/sellers/Ventero-4BD2.jpg';
import Ventero5B from '../assets/images/sellers/Ventero-5B2.jpg';
import Ventero6B from '../assets/images/sellers/Ventero-6B.jpg';
import Ventero7B from '../assets/images/sellers/Ventero-7B.jpg';
import Ventero8B from '../assets/images/sellers/Ventero-8B2.jpg';
import Ventero9B from '../assets/images/sellers/Ventero-9B2.jpg';
import Ventero10B from '../assets/images/sellers/Ventero-10B.jpg';

import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const context = useContext(MyContext);
    const navigate = useNavigate();

    useEffect(() => {
        const images = [Ventero1B, Ventero2B, Ventero3B, Ventero4B, Ventero5B, Ventero6B, Ventero7B, Ventero8B, Ventero9B, Ventero10B];
        const date = new Date();
        const day = date.getDate();
        const selectedImage = images[day % images.length];

        const loginContainer = document.querySelector('.login-container') as HTMLElement;
        if (loginContainer) {
            loginContainer.style.backgroundImage = `url(${selectedImage})`;
        }
    }, []);

    if (context === undefined) {
        throw new Error('Login must be used within a MyProvider');
    }

    const { isAuthenticated, login } = context;

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/home');
        }
    }, [isAuthenticated, navigate]);

    //Handle summit, calling Sergio's Api (https://www.medellin.gov.co) from sivep backend, login endpoint
    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (isSubmitting) return;

        setIsSubmitting(true);

        const emailPattern = /^[a-zA-Z0-9._%+-]+@medellin\.gov\.co$/;
        const cedulaPattern = /^\d{6,15}$/;

        const adminPattern = /^admin$/i; // Nueva expresión para admin (case insensitive)

        const cleanedUsername = username.trim();
        const cleanedPassword = password.trim();

        if (!emailPattern.test(cleanedUsername) &&
            !cedulaPattern.test(cleanedUsername) &&
            !adminPattern.test(cleanedUsername)) {
            alert("Por favor ingrese:\n- Un número de cédula de 6 a 15 dígitos\n- O un correo electrónico con dominio @medellin.gov.co\n");
            setIsSubmitting(false);
            return;
        }

        const getApiUrl = () => {
            const hostname = window.location.hostname;

            if (process.env.NODE_ENV === 'production') {
                return process.env.REACT_APP_BACK_URL;
            } else if (hostname === 'localhost' || hostname === process.env.REACT_HOST_NAME) {
                return process.env.REACT_APP_BACK_DEV_MAC;
            } else {
                return process.env.REACT_APP_BACK_DEV_MOBIL;
            }
        };

        let domainToFetch = getApiUrl();
        console.log('domainToFetch', domainToFetch)
       // let domainToFetch = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_BACK_DEV : process.env.REACT_APP_BACK_URL;

        try {
            const response = await fetch(`${domainToFetch}/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    username: cleanedUsername,
                    password: cleanedPassword
                })
            });

            const data = await response.json();
            console.log('data',data)

            if (!response.ok) {
                throw new Error(data.message || 'Error al iniciar sesión');
            }

            if (data.success && data.token && data.user.activo) {

                // Save data to localStorage
                localStorage.setItem('authToken', data.token);
                localStorage.setItem('userData', JSON.stringify(data.user));

                // Update context
                context.login({
                    id: data.user.id,
                    grupo: data.user.grupo,
                    nombre: data.user.nombre,
                    apellido: data.user.apellido,
                    email: data.user.email,
                    token: data.token,
                    activo: data.user.activo
                });
            } else {
                throw new Error(data.message || 'Usuario no activo en el sistema');
            }

        } catch (error) {
            console.error('Error en login:', error);
            alert(error instanceof Error ? error.message : 'Error al iniciar sesión');
        } finally {
            setIsSubmitting(false);
        }
    };

    // Login simulation for testing purposes
    const handleSubmit2 = async (event: React.FormEvent) => {
        event.preventDefault();
        if (isSubmitting) return;

        setIsSubmitting(true);

        const emailPattern = /^[a-zA-Z0-9._%+-]+@medellin\.gov\.co$/;
        const cedulaPattern = /^\d{6,15}$/;

        const cleanedUsername = username.trim();
        const cleanedPassword = password.trim();

        if (!emailPattern.test(cleanedUsername) && !cedulaPattern.test(cleanedUsername)) {
            alert("Por favor ingrese:\n- Un número de cédula de 6 a 15 dígitos\n- O un correo electrónico con dominio @medellin.gov.co");
            setIsSubmitting(false);
            return;
        }

        try {
            // SIMULACIÓN TEMPORAL: omitir la API real
            const simulatedResponse = {
                success: true,
                token: 'fake-jwt-token',
                user: {
                    id: 1,
                    grupo: 1,
                    nombre: 'Juan',
                    apellido: 'Pérez',
                    email: 'juan.perez@medellin.gov.co',
                    activo: true
                }
            };

            // Guardar en localStorage
            localStorage.setItem('authToken', simulatedResponse.token);
            localStorage.setItem('userData', JSON.stringify(simulatedResponse.user));

            // Actualizar contexto
            context.login({
                id: simulatedResponse.user.id,
                grupo: simulatedResponse.user.grupo,
                nombre: simulatedResponse.user.nombre,
                apellido: simulatedResponse.user.apellido,
                email: simulatedResponse.user.email,
                token: simulatedResponse.token,
                activo: simulatedResponse.user.activo
            });
        } catch (error) {
            console.error('Error en login simulado:', error);
            alert(error instanceof Error ? error.message : 'Error al iniciar sesión');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="login-container">
            <form className="login-form" onSubmit={handleSubmit}>
                <div className="logos-group">
                    <img src={logoAlcaldia} alt="Logo" className="login-logo"/>
                    <hr className="divider" />
                    <img src={logoSivep} alt="Logo" className="login-logo-sivep"/>
                </div>
                <label>INGRESA A TU CUENTA</label>
                <div className="form-group">
                    <img src={userIcon} alt="User icon" className="icon"/>
                    <input
                        type="text"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        placeholder="Cédula o correo electronico"
                        pattern="^(\d{6,15}|[a-zA-Z0-9._%+-]+@medellin\.gov\.co)$"
                        title="Ingrese un número de cédula válido o un correo del dominio @medellin.gov.co"
                        className="input-icon"
                    />
                </div>
                <div className="form-group">
                    <img src={padlockIcon} alt="Lock icon" className="icon" style={{ width: '20px', height: '20px' }} />
                    <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        placeholder="Contraseña"
                        className="input-icon"
                    />
                </div>
                <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="toggle-password"
                >
                    <i className={showPassword ? "fa-regular fa-eye-slash" : "fa-regular fa-eye"}></i>
                </button>
                <button
                    className="login-button"
                    type="submit"
                    disabled={isSubmitting} // Disable the button if isSubmitting is true
                >
                    {isSubmitting ? 'Espere...' : 'Iniciar Sesión'}
                </button>
            </form>
        </div>
    );
};

export default Login;
